import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  background-color: #f0f0f0; /* Cambia el color de fondo según tus preferencias */
  padding: 10px;
  justify-content: space-between;
`;

const Label = styled.label`
  text-align: right;
  margin-right: 10px; /* Agrega margen derecho para crear espacio */
`;

const InputContainer = styled.div`
  flex-grow: 1;
  display: flex;
  align-items: center;
  background-color: #fff; /* Cambia el color de fondo según tus preferencias */
  border-radius: 5px;
  padding: 5px;
`;

const SearchInput = styled.input`
  border: none;
  outline: none;
  flex-grow: 1;
  padding: 5px;
`;

const SearchButton = styled.button`
  background-color: #007bff; /* Cambia el color del botón según tus preferencias */
  color: #fff;
  border: none;
  border-radius: 5px;
  padding: 5px 10px;
  margin-left: 5px;
`;

const ExportButton = styled.button`
  background-color: #28a745; /* Cambia el color del botón según tus preferencias */
  color: #fff;
  border: none;
  border-radius: 5px;
  padding: 5px 10px;
  margin-left: 5px;
`;

const SearchIcon = styled.i`
  margin-right: 5px;
`;

const ExportIcon = styled.i`
  margin-right: 5px;
`;

const SelectAllCheckbox = styled.input`
  margin-right: 5px;
`;

const BarraBuscador = () => {
  const [selectAll, setSelectAll] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [datosAmostrar, actualizarDatosAMostrar] = useState( []);
  const [todosLosProductos, actualizarTodosLosProductos] = useState( []);

  const handleSelectAll = () => {
    setSelectAll(!selectAll);
    // Aquí puedes implementar la lógica para seleccionar todos los elementos.
  };

  const handleChange=(e)=>{
    setSearchText(e.target.value);
    console.log(e.target.value);
    filterData(e.target.value);
  }




  const filterData = (valorABuscar) => {
    actualizarDatosAMostrar(todosLosProductos);
      const datosFiltrados = datosAmostrar.filter((item) => {
        return Object.keys(item).some((key) =>
          item[key].toString().toLowerCase().includes(valorABuscar)
        );
      });
      actualizarDatosAMostrar(datosFiltrados);
    }



  return (
    <Container>
      
      <InputContainer>
        <SearchInput type="text" placeholder="Escribe aquí..." value={searchText}
        onChange={handleChange}/>
        <SearchButton>
          <SearchIcon className="fas fa-search"></SearchIcon>
          Buscar
        </SearchButton>
      </InputContainer>
     
    </Container>
  );
};

export default BarraBuscador;